import moment from 'moment'

export default function (value) {
  if (!value) return '...'
  return moment.utc(value).local().format('M/D/YYYY h:mm A')
}
